export const reStructureSegment = (fetchArray: any) => {
  const segmentsWithPage = fetchArray?.Segments?.map((segment: any) => ({
    ...segment,
    page: fetchArray.Page,
  }));

  return segmentsWithPage;
};

export const replaceArrayOfObjects = (fetchArray: any, existArray: any) => {
  const updatedArray = existArray?.map((segment: any, index: number) => {
    const fetchSegment = fetchArray?.find(
      (fs: any, index: number) =>
        fs.ProductOfferingSegmentId === segment.ProductOfferingSegmentId
    );
    return fetchSegment ? { ...segment, ...fetchSegment } : segment;
  });

  return updatedArray;
};
